import { firebaseApp } from '../../../data/config';
import authStorage from '../../mobx/authStorage';
import appState from '../../mobx/appState';

export default function firebaseCheckAuth() {
  return new Promise((resolve, reject) => firebaseApp.auth().onAuthStateChanged((user) => {
    authStorage.authStateChanged(user);
    resolve(user);
    appState.isReady = true;
  }));
}
